import { AppState } from '~system/store/configure-store';

export const selectConfirmationModal = (state: AppState) =>
  state.modal.confirmation;

export const selectSpecificModal = (state: AppState) => state.modal.specific;

export const selectRegularModal = (state: AppState) => state.modal.regular;
